export default {"src":"/_next/static/media/creditcard-flash.58dd3505.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};